import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerPersona,
  BackendMutationUpdateCustomerPersonasArgs,
} from 'src/types/backend';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateCustomerPersonas(
    $personas: [CustomerPersonaInput!]!
    $projectId: ID
    $approve: Boolean
    $brandVoiceId: ID
  ) {
    updateCustomerPersonas(
      personas: $personas
      projectId: $projectId
      approve: $approve
      brandVoiceId: $brandVoiceId
    ) {
      ...CustomerPersona
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

type Variables = BackendMutationUpdateCustomerPersonasArgs;
type Result = BackendCustomerPersona[];

export const updateCustomerPersonas = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
